import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { database } from '../data/database.ts';

const ProductDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [product, setProduct] = useState<any>(null);
  const [dynamicMessage, setDynamicMessage] = useState<string>('');

  const db = database;

  useEffect(() => {
    const productId = parseInt(id || '', 10);
    const selectedProduct = db.products.items.find(item => item.id === productId);
    console.log(selectedProduct);
    setProduct(selectedProduct);
    setDynamicMessage(`${selectedProduct?.name}`);
  }, [id, db]);

  if (!product) {
    return <div>Producto no encontrado</div>;
  }

  return (
    <div className='product-detail-section'>
      <div className="container">
        <div className='row'>
          <div className='col-lg-6'>
            <img className='product-detail-image' src={product.hoverImage} alt={product.name} />
          </div>
          <div className='col-lg-6'>
            <h1 className='product-detail-title'>{product.name}</h1>
            <p className='product-detail-price'>Precio: {product.currency} {product.priceFinalOffer}.00</p>
            {
              product.period !== "(Sin duración especificada)" && (
                <p className='product-detail-period'>Duración: {product.period}</p>
              )
            }
            <p className='product-detail-description'>{product.description}</p>
            <a className='product-detail-button' href={`${db.walinkproduct}${encodeURIComponent(dynamicMessage)}`}>Contáctanos y continúa tu compra</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;